import { Button, Container, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Header from "../../../Shared/Header/Header";

const Contact = () => {
  const handleMessage = (e) => {
    e.preventDefault();
  };
  return (
    <div
      style={{
        background:
          "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Header />
      <Container>
        <Box data-aos="fade-down-right">
          <Typography
            className="section-title"
            sx={{ color: "whitesmoke", mb: 10 }}
            variant="h3"
          >
            Contact
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper data-aos="zoom-out-down" sx={{ height: "50vh" }}>
            <form
              onSubmit={handleMessage}
              style={{ textAlign: "center", marginTop: "10px" }}
            >
              <TextField
                sx={{ width: "75%", m: 1 }}
                id="standard-basic"
                label="Your Name"
                variant="standard"
                type="text"
                name="name"
                // onChange={handleOnChange}
              ></TextField>
              <TextField
                sx={{ width: "75%", m: 1 }}
                id="standard-basic"
                label="Your Email"
                variant="standard"
                type="email"
                name="email"
                // onChange={handleOnChange}
              ></TextField>
              <TextField
                sx={{ width: "75%", m: 1 }}
                id="standard-basic"
                label="Your Massage"
                variant="standard"
                type="password"
                name="password"
                // onChange={handleOnChange}
              ></TextField>
              <br />
              <Button
                sx={{ width: "75%", mt: 3, backgroundColor: "black" }}
                type="submit"
                variant="contained"
              >
                Send Massage
              </Button>
            </form>
          </Paper>
        </Box>
      </Container>
    </div>
  );
};

export default Contact;
